import { render, staticRenderFns } from "./TemplateDataGridWrapper.vue?vue&type=template&id=51509fa1"
import script from "./TemplateDataGridWrapper.vue?vue&type=script&lang=js"
export * from "./TemplateDataGridWrapper.vue?vue&type=script&lang=js"
import style0 from "./TemplateDataGridWrapper.vue?vue&type=style&index=0&id=51509fa1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports